import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { CommercialImpactInput } from '../../../viewmodels/commercial-impacts/commercial-impact-input';
import { CommercialImpactItemType, CommercialImpactsService } from '../commercial-impacts.service';

@Component({
  selector: 'hb-commercial-impact-inputs',
  templateUrl: './commercial-impact-inputs.component.html',
  styleUrls: ['./commercial-impact-inputs.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CommercialImpactInputsComponent implements OnInit {
  @Input() form: NgForm;
  @Input() isReadOnly: boolean;
  @Input() isProductionTable: boolean;
  @Input() itemType: CommercialImpactItemType;

  constructor(private commercialImpactsService: CommercialImpactsService) {}

  ngOnInit() {}

  getCommercialImpactInputs(): CommercialImpactInput[] {
    return this.commercialImpactsService.getCommercialImpactInputs(this.itemType);
  }

  addCommercialImpactInput() {
    this.commercialImpactsService.addCommercialImpactInput(this.itemType);
  }

  deleteCommercialImpactInput(index: number) {
    this.commercialImpactsService.deleteCommercialImpactInput(this.itemType, index);
  }

  calculateCurrentInputTotal(index: number): number {
    return this.commercialImpactsService.calculateCurrentInputTotal(this.itemType, index);
  }
}
